import { axiosFactory, errorHandler } from '@/configs/axios'

const fleetStat = {
  api: () => {
    return axiosFactory()
      .auth.get('stats/fleets/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {})
  },
}

export const DownloadNotUpdated = {
  api: () => {
    return axiosFactory({ type: 'blob' })
      .auth.get(`exports/vehicles/companies/not-updated/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const fleetToday = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`stats/fleets/today/${payload || ''}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {})
  },
}

export const fleetTodays = {
  api: () => {
    return axiosFactory()
      .auth.get(`stats/fleets/todays/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {})
  },
}

const fleetStatus = {
  api: () => {
    return axiosFactory()
      .auth.get('/stats/fleets/statuses/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const driversStats = {
  api: () => {
    return axiosFactory()
      .auth.get('/stats/drivers/statuses/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const vehiclesOwnershipStats = {
  api: () => {
    return axiosFactory()
      .auth.get('/stats/company-vehicles/ownerships/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
export const vehiclesStats = {
  api: () => {
    return axiosFactory()
      .auth.get('/stats/company-vehicles/statuses/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const hasHardware = {
  api: () => {
    return axiosFactory()
      .auth.get('api/customer-vehicles/v1/has-hardware/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const liveTracking = {
  api: (payload) => {
    return axiosFactory({ base: false })
      .auth.post('https://live-tracking.carpo.tech/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export { hasHardware, liveTracking, fleetStat, fleetStatus }
